import { useEffect, useMemo } from "react";

export function useUnmountedCancellation(): AbortSignal {
	const cancellation = useMemo(
		(): AbortController => new AbortController(),
		[]
	);

	useEffect(
		() => {
			return () => cancellation.abort();
		},
		[cancellation]
	);

	return cancellation.signal;
}